import P2Regular from 'components/typography/P2Regular';
import { MeasuringDeviceRow } from 'components/tables/data/measuring-device/types';

/**
 * Column for the manufacturer.
 */
export default function ManufacturerColumn({ data: { manufacturer } }: { data: MeasuringDeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {manufacturer}
    </P2Regular>
  );
}
